import { normalizeRoomCode } from "../shared/protocol";

const ROOM_SESSION_KEY = "terminal-arcade-room";

export function readPersistedRoomCode(): string | null {
  try {
    return normalizeRoomCode(sessionStorage.getItem(ROOM_SESSION_KEY) ?? "");
  } catch {
    return null;
  }
}

export function persistRoomCode(roomCode: string): void {
  try {
    sessionStorage.setItem(ROOM_SESSION_KEY, roomCode);
  } catch {
    // Private mode or blocked storage — URL invite still works.
  }
}

export function clearPersistedRoomCode(): void {
  try {
    sessionStorage.removeItem(ROOM_SESSION_KEY);
  } catch {
    // Ignore storage failures on leave.
  }
}
